export default __webpack_public_path__ + "static/media/vishwaratna.63bc25e4.jpg";